import styled from '@emotion/styled';
import { TablePropsType, TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, ChevronDownType, ChevronDownWrapperTemplate, TableSelectCellClickableTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';
import { fraudAndComplianceColors } from 'src/assets/colors';

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })`
`;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })`
`;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' }) <TablePropsType>`
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
    :nth-of-type(1) {
        width: 35px;
    }
    :nth-of-type(2) {
        width: 20%
    }
    :nth-of-type(3) {
        width: 20%
    }
    :nth-of-type(4) {
        width: 20%
    }
    :nth-of-type(5) {
        width: 10%
    }
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`

    :nth-of-type(2) {
        width: 20%
    }
    :nth-of-type(3) {
        width: 20%
    }
    :nth-of-type(4) {
        width: 20%
    }
    :nth-of-type(5) {
        width: 10%
    }

    span {
        display: block;
    }
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
`;

export const ChevronDownWrapper = styled(ChevronDownWrapperTemplate, { label: 'ChevronDownWrapper' }) <ChevronDownType>`
`;

export const TableSelectCellClickable = styled(TableSelectCellClickableTemplate, { label: 'TableSelectCellClickable' })`
    width: 35px;
`;

export const RowWithTable = styled('td', { label: 'RowWithTable' })`
    padding: 0 !important;
`;

export const InnerTable = styled('table', { label: 'InnerTable' })`
    vertical-align: middle;
`;

export const TableRowAddColor = styled('tr', { label: 'TableRowAddColor' })`
    background: inherit !important; //remove after delete class .fraud-and-compliances-tab
`;

export const CustomerTab = styled('div', { label: 'CustomerTab' })`
     background: ${fraudAndComplianceColors.matchedAccount.bgColorCustomerTab} !important; //remove after delete class '.fraud-and-compliance .customerTab'
`;
